import { FormattedMessage } from 'react-intl';

import { Grid, Typography } from '@mui/material';

import { useStrOfferingData } from '@arrived/common';
import { Offering } from '@arrived/models';

import { PROPERTY_HASH_MAP } from '../Property.constants';
import { PropertyDetailsSection } from './PropertyDetailsSection';
import { PropertyDetailsTooltip } from './PropertyDetailsTooltip';

import { PropertyDetailsQuickLookItem } from './quickLook';

export interface PropertyDetailsManagementInfoProps {
  offering: Offering;
}

export const PropertyDetailsManagementInfo = ({ offering }: PropertyDetailsManagementInfoProps) => {
  const managementInfo = useStrOfferingData(offering.id).propertyManagement;

  return (
    <PropertyDetailsSection
      hash={PROPERTY_HASH_MAP.rentInfo}
      title={
        <FormattedMessage id="property-details-management-info-title" defaultMessage="Property Management Partner" />
      }
      description={
        <FormattedMessage
          id="property-details-management-info-description"
          defaultMessage={`Preparing a home for the short term rental market is a multi-tiered process that begins
           as soon as the property is acquired. Our experienced investment team works closely with the
           local property managers to get it show-ready, determine optimal market rent, take high-quality
            photos and videos, market the rental through various online and offline channels, screen and
             thoroughly vet tenant applications, and finalize the lease terms. Below you can find more
             information regarding this offering's property management partner and the expected rent-ready date.
      `}
        />
      }
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h5.semibold">{managementInfo.name}</Typography>
          <Typography>{managementInfo.description}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
          <PropertyDetailsQuickLookItem
            label={
              <PropertyDetailsTooltip
                title={
                  <FormattedMessage
                    id="management-info-partner-launch-date-tooltip"
                    defaultMessage="The estimated launch date when this property is expected to begin accepting bookings from guests."
                  />
                }
              >
                <FormattedMessage id="rent-info-rental-status-title" defaultMessage="Rent-Ready Date" />
              </PropertyDetailsTooltip>
            }
            value={managementInfo.estimatedLaunchDate}
          />
        </Grid>
        {offering.projectedFirstDividendDate && (
          <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
            <PropertyDetailsQuickLookItem
              label={
                <PropertyDetailsTooltip title={<FormattedMessage id="first.dividend.date.description" />}>
                  <FormattedMessage id="first.dividend.date" />
                </PropertyDetailsTooltip>
              }
              value={offering.projectedFirstDividendDate}
            />
          </Grid>
        )}
      </Grid>
    </PropertyDetailsSection>
  );
};
